import { type FilterItem } from 'widgets/FilterEditor/model'

export const EmptyOperators = new Set(['is_known', 'is_unknown', 'last_week', 'last_month'])

export const isEmptyWidget = (filterItem: FilterItem) =>
  !!filterItem.operator && EmptyOperators.has(filterItem.operator.key)
